<template>
  <div>
    <CTableWrapper
      :items="languages"
      :is-loading="isLoading"
      small
      fixed
      border
      sorter
      :sorter-value="{ column: 'name', asc: true }"
      column-filter
      :fields="fields"
      type="Language"
      icon="cil-tags"
      caption="Languages"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import CTableWrapper from '@/components/common/Table.vue'
export default {
  name: 'Languages',

  title: 'Languages',

  components: {
    CTableWrapper
  },
  data() {
    return {
      isLoading: false,
      fields: [
        { key: 'status', sortable: true },
        { key: 'id', label: 'ID', sortable: true },
        { key: 'name', sortable: true },
        { key: 'subId', label: 'Sub ID', sortable: true },
        { key: 'Actions', filter: false }
      ]
    }
  },
  computed: {
    ...mapState('language', ['languages'])
  },
  async created() {
    this.isLoading = true
    await this.list()
    this.isLoading = false
  },
  methods: {
    ...mapActions('language', ['list'])
  },
}
</script>
<style lang="scss" scoped></style>
